import { getAuthAxiosBackend } from "@/helpers/axios"

class LevelTwoServices {
    get(id) {
        return getAuthAxiosBackend().get('LevelTwo/getLevelTwoById/' + id.toString())
    }

    getAll(data = {}) {
        return getAuthAxiosBackend().get('LevelTwo/all', { params: data })
    }

    add(data) {
        return getAuthAxiosBackend().post('LevelTwo/addLevelTwo', data)
    }

    edit(id, data) {
        return getAuthAxiosBackend().put('LevelTwo/updateLevelTwo/' + id, data)
    }

    restore(id, data) {
        return getAuthAxiosBackend().put('LevelTwo/restoreLevelTwo' + id, data)
    }

    delete(id) {
        return getAuthAxiosBackend().delete('LevelTwo/softDeleteLevelTwo/' + id.toString())
    }

    forceDelete(id) {
        return getAuthAxiosBackend().delete('LevelTwo/deleteLevelTwo/' + id.toString())
    }
}

export default new LevelTwoServices()
